"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapReplace = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Replace passed object keys on their values in string.
 * @param {string} str
 * @param {Object.<string, string>} map
 *
 * @example
 * const message = 'Dear Bob, some text here Best regards, Peter';
 * const map = { [`\\bBob\\b`]: 'Dan', [`\\bPeter\\b`]: 'Anakin' };
 *
 * mapReplace(message, map); // 'Dear Dan, some text here Best regards, Anakin'
 *
 * @return {string}
 */
var mapReplace = function mapReplace(str, map) {
  return Object.entries(map).reduce(function (finalStr, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        regExp = _ref2[0],
        value = _ref2[1];

    return finalStr.replace(new RegExp(regExp, 'g'), value);
  }, str);
};

exports.mapReplace = mapReplace;